<template>
    <transition name="new-version-modal-fade">
        <div v-if="visible" class="new-version-modal-overlay" @click.self="handleClose">
            <div class="new-version-modal-container" @click.stop>
                <div class="new-version-modal-header">
                    <button class="new-version-modal-close-button" @click="handleClose">
                        <i class="material-icons">close</i>
                    </button>
                </div>
                
                <div class="new-version-modal-content">
                    <div class="new-version-modal-icon-wrapper">
                        <i class="material-icons new-version-modal-update-icon">system_update</i>
                    </div>
                    
                    <h2 class="new-version-modal-title">Yeni Sürüm Mevcut</h2>
                    <p class="new-version-modal-description">Yeni bir sürüm mevcut. Lütfen yeni sürüme geçmek için aşağıdaki butona tıklayın.</p>
                    
                    <div class="new-version-modal-version-info">
                        <div class="new-version-modal-version-badge">
                            <i class="material-icons">info_outline</i>
                            <span>Mevcut Sürüm: <strong>{{ versionStr }}</strong></span>
                        </div>
                    </div>
                </div>
                
                <div class="new-version-modal-footer">
                    <button class="new-version-modal-cancel-button" @click="handleClose">
                        Daha Sonra
                    </button>
                    <button class="new-version-modal-update-button" @click="handleUpdate">
                        <i class="material-icons">download</i>
                        <span>Yeni Sürümü Yükle</span>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "NewVersionModal",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        versionStr: {
            type: String,
            default: "",
        },
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        handleUpdate() {
            this.$emit('update');
        },
    },
};
</script>

<style lang="scss" scoped>
.new-version-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 20px;
}

.new-version-modal-container {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    max-width: 480px;
    width: 100%;
    overflow: hidden;
    position: relative;
    animation: new-version-modal-slide-in 0.3s ease-out;
}

@keyframes new-version-modal-slide-in {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.new-version-modal-header {
    display: flex;
    justify-content: flex-end;
    padding: 16px 20px 0;
}

.new-version-modal-close-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #64748b;

    &:hover {
        background: #f1f5f9;
        color: #334155;
    }

    .material-icons {
        font-size: 20px;
    }
}

.new-version-modal-content {
    padding: 24px 32px 32px;
    text-align: center;
}

.new-version-modal-icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
}

.new-version-modal-update-icon {
    font-size: 64px;
    color: #4F46E5;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #EEF2FF;
    border-radius: 50%;
}

.new-version-modal-title {
    font-size: 24px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 12px;
    line-height: 1.3;
}

.new-version-modal-description {
    font-size: 15px;
    color: #64748b;
    line-height: 1.6;
    margin: 0 0 24px;
}

.new-version-modal-version-info {
    display: flex;
    justify-content: center;
    margin-top: 24px;
}

.new-version-modal-version-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: #f8fafc;
    border-radius: 8px;
    font-size: 14px;
    color: #475569;
    border: 1px solid #e2e8f0;

    .material-icons {
        font-size: 18px;
        color: #4F46E5;
    }

    strong {
        color: #1e293b;
        font-weight: 600;
    }
}

.new-version-modal-footer {
    display: flex;
    gap: 12px;
    padding: 20px 32px 32px;
    border-top: 1px solid #f1f5f9;
}

.new-version-modal-cancel-button {
    flex: 1;
    height: 44px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #f8fafc;
        border-color: #cbd5e1;
        color: #475569;
    }

    &:active {
        transform: scale(0.98);
    }
}

.new-version-modal-update-button {
    flex: 2;
    height: 44px;
    border: none;
    background: #4F46E5;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.3);

    &:hover {
        background: #4338CA;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(79, 70, 229, 0.4);
    }

    &:active {
        transform: translateY(0);
    }

    .material-icons {
        font-size: 20px;
    }
}

.new-version-modal-fade-enter-active,
.new-version-modal-fade-leave-active {
    transition: opacity 0.2s ease;
}

.new-version-modal-fade-enter,
.new-version-modal-fade-leave-to {
    opacity: 0;
}

// Dark mode support
.dark-mode {
    .new-version-modal-overlay {
        background: rgba(0, 0, 0, 0.7);
    }

    .new-version-modal-container {
        background: #1e293b;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    }

    .new-version-modal-title {
        color: #ffffff;
    }

    .new-version-modal-description {
        color: #94a3b8;
    }

    .new-version-modal-close-button {
        color: #94a3b8;

        &:hover {
            background: #334155;
            color: #ffffff;
        }
    }

    .new-version-modal-update-icon {
        background: rgba(79, 70, 229, 0.2);
        color: #818CF8;
    }

    .new-version-modal-version-badge {
        background: #334155;
        border-color: #475569;
        color: #cbd5e1;

        .material-icons {
            color: #818CF8;
        }

        strong {
            color: #ffffff;
        }
    }

    .new-version-modal-cancel-button {
        background: #334155;
        border-color: #475569;
        color: #94a3b8;

        &:hover {
            background: #475569;
            border-color: #64748b;
            color: #ffffff;
        }
    }

    .new-version-modal-footer {
        border-top-color: #334155;
    }
}

// Responsive
@media (max-width: 600px) {
    .new-version-modal-container {
        max-width: 100%;
        margin: 0 16px;
    }

    .new-version-modal-content {
        padding: 20px 24px 24px;
    }

    .new-version-modal-header {
        padding: 16px 20px 0;
    }

    .new-version-modal-footer {
        padding: 16px 24px 24px;
        flex-direction: column;
    }

    .new-version-modal-cancel-button,
    .new-version-modal-update-button {
        flex: 1;
        width: 100%;
    }

    .new-version-modal-update-icon {
        font-size: 56px;
        width: 70px;
        height: 70px;
    }

    .new-version-modal-title {
        font-size: 22px;
    }

    .new-version-modal-description {
        font-size: 14px;
    }
}
</style>

